import { TdsDropdown, TdsDropdownOption } from "@scania/tegel-react";
import { Controller, useFormContext } from "react-hook-form";
import { debounce } from "lodash";
import { useEffect } from "react";
import { ChainItemTypeEnum } from "../../../helpers/dataHelper";
interface TypeDropdownPropType {
  selectedValue?: any,
  onItemTypeChange?: (newType: ChainItemTypeEnum) => void
  index: number
  readonly?:boolean
}

const TypeDropDown = ({ selectedValue, onItemTypeChange, index, readonly }: TypeDropdownPropType) => {
  const { setValue, watch, register, control,setError,clearErrors } = useFormContext();
  const fieldName = `chain.${index}.type`;
  const selectValue = selectedValue || watch(fieldName);

  const onTdsChange = (e: TdsDropdownEvent) => {
    if(!readonly){
      onItemTypeChange ? onItemTypeChange(e.detail.value as ChainItemTypeEnum) : console.log(e.detail.value);
      setValue(fieldName, e.detail.value)
      clearErrors(fieldName);
    }else{
      e.preventDefault();
      e.stopPropagation()
      e.stopImmediatePropagation();
    }
    if (e.detail.value === '') {
      setError(fieldName, { message: "Type is required!", type: "required" }, { shouldFocus: true })
    }
  }
  useEffect(() => {
    register(fieldName, { required: "Type is required!", value: "Type \"Input\" is can't be changed!" })
  })
  useEffect(() => {
    if (selectValue) {
      const fieldName = `chain.${index}.type`;
      setValue(fieldName, selectValue)
    }
  }, [selectValue, index, setValue])

  return <Controller
    name={fieldName}
    control={control}
    render={({ field: { value, onBlur }, fieldState: { error } }) => (
      <TdsDropdown
        modeVariant='primary'
        label='Type *'
        labelPosition='outside'
        placeholder="Select Type"
        size='md'
        onTdsChange={debounce((onTdsChange), 300)}
        defaultValue={value || selectValue}
        onTdsBlur={onBlur}
        error={error && error?.type === "required"}
        helper={error && error.type === "required" ? "Type is required!" : ""}
        disabled={readonly}
      >
        {Object.entries(ChainItemTypeEnum).map(([key, value], index) => {
          return <TdsDropdownOption value={value} key={`${key}-${index}`}>{key}</TdsDropdownOption>
        })}
      </TdsDropdown>
    )} />
}

export default TypeDropDown